module.exports = __webpack_public_path__ + "static/media/2.d14b46e2.png";